import { render } from "./FamilySidebar.vue?vue&type=template&id=2c77eb48&ts=true"
import script from "./FamilySidebar.vue?vue&type=script&lang=ts"
export * from "./FamilySidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__